import React, { createContext, useReducer } from 'react'
import AppReducer from './reducer'

const initialState = {
  params: '',
  entity_params: ''
}

function AppStore({ children }) {
  const [state, dispatch] = useReducer(AppReducer, initialState)
  return (
    <AppContext.Provider value={[state, dispatch]}>{children}</AppContext.Provider>
  )
}

export const AppContext = createContext(initialState)
export default AppStore
